module.exports = __webpack_public_path__ + "media/images/Divorcee-Matrimony-Banner2-bbf38846fa76436a0eb46ac83caa9b52.jpg";